import { render, staticRenderFns } from "./ErrorContentCapter.vue?vue&type=template&id=29b88f53&scoped=true&"
import script from "./ErrorContentCapter.vue?vue&type=script&lang=js&"
export * from "./ErrorContentCapter.vue?vue&type=script&lang=js&"
import style0 from "./ErrorContentCapter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ErrorContentCapter.vue?vue&type=style&index=1&id=29b88f53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b88f53",
  null
  
)

export default component.exports